// This is an example file and is expected to be cloned
// without the -example on the same folder that it resides.

const theme = {
  primary: '#C62828',
  secondary: '#8e0000',
  accent: '#ff5f52',
  error: '#f44336', // color used to show error toaster
  warning: '#FFD54F', // color used to show warning toaster
  info: '#2196f3', // color used to show info toaster
  success: '#4caf50', // color used to show success toaster
  dark: '#424242',
  neutral: '#f0f1f4'
}
export default theme
